(function () {
  if (window.customElements && customElements.get('promo-countdown')) return;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function box(num, unit) {
    return '<span class="promo-cd__box"><span class="promo-cd__num">' + num + '</span><span class="promo-cd__unit">' + unit + '</span></span>';
  }

  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      var end = parseInt(this.getAttribute('data-end'), 10);
      if (!end || isNaN(end)) {
        this.hideStrip();
        return;
      }
      this.endMs = end * 1000;
      this.render();
      this.timer = setInterval(this.render.bind(this), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    hideStrip() {
      var strip = this.closest('.promo-strip');
      if (strip) strip.style.display = 'none';
    }

    render() {
      var diff = this.endMs - Date.now();
      if (diff <= 0) {
        if (this.timer) clearInterval(this.timer);
        this.hideStrip();
        return;
      }
      var total = Math.floor(diff / 1000);
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;
      if (this.getAttribute('data-style') === 'boxes') {
        this.innerHTML =
          '<span class="promo-cd__label">Ends in</span>' +
          box(days, days === 1 ? 'Day' : 'Days') +
          box(pad(hours), 'Hrs') +
          box(pad(mins), 'Min') +
          box(pad(secs), 'Sec');
        return;
      }
      var label = days === 1 ? ' (Day) ' : ' (Days) ';
      this.textContent = 'Ends in: ' + days + label + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
    }
  }

  customElements.define('promo-countdown', PromoCountdown);
})();
